import {
  IconButton,
  PaletteIcon,
  PaletteSlashIcon,
  Tooltip,
} from '@frontend/legacy-components';

type ToggleColoringButtonProps = {
  isColoringOn: boolean;
  onToggleColoring: () => void;
  hideColoringLabel: string;
  showColoringLabel: string;
};

export const ToggleColoringButton = ({
  isColoringOn,
  onToggleColoring,
  hideColoringLabel,
  showColoringLabel,
}: ToggleColoringButtonProps) => (
  <Tooltip
    placement="top"
    label={isColoringOn ? hideColoringLabel : showColoringLabel}
  >
    <IconButton
      size="sm"
      aria-label={isColoringOn ? hideColoringLabel : showColoringLabel}
      aria-pressed={isColoringOn}
      onClick={onToggleColoring}
    >
      {isColoringOn ? (
        <PaletteIcon boxSize={2.5} />
      ) : (
        <PaletteSlashIcon boxSize={2.5} />
      )}
    </IconButton>
  </Tooltip>
);
ToggleColoringButton.displayName = 'ToggleColoringButton';
